import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

// Import's Services:
import {
  ServicioCertificadoOcupacionalService,
  CertificadoServiceEntity,
  CertificadoDatosEntity,
  CertificadoPreguntasEntity
} from "src/app/services/servicio-certificado-ocupacional.service";

import {
  ServicioImagenesService,
  ObjetoImagenesEntity,
  ObjetoImagenesReponseEntity
} from "src/app/services/servicio-imagenes.service";
import { DataPermisosService } from "src/app/services/utils/data-permisos.service";

@Component({
  selector: "app-reporte-certificado-ocupacional",
  templateUrl: "./reporte-certificado-ocupacional.component.html",
  styleUrls: ["./reporte-certificado-ocupacional.component.css"]
})
export class ReporteCertificadoOcupacionalComponent implements OnInit {

  // Objeto parámetros Certificado Ocupacional:
  private objetoCertificado: CertificadoServiceEntity = {
    codigoBaseDatos: "",
    id: ""
  };

  // Objeto parámetros Imagenes Certificado Ocupacional:
  private objetoImagenes : ObjetoImagenesEntity = {
    codigoBaseDatos : "",
    idEntidad : "",
    id : ""
  }

  // Este objeto tiene los datos de la cabecera del Certificado Ocupacional:
  public objetoSectionCertificado: any = {
    fechaAtencion: null,
    ciudad: "",
    empresa: ""
  };

  // Este objeto tiene los datos del Colaborador del Certificado Ocupacional:
  public objetoSectionColaborador: any = {
    nombre: "",
    numeroIdentificacion: "",
    tipoIdentificacion: "",
    fechaNacimiento: null,
    sexo: "",
    direccion: "",
    sector: "",
    cargo: "",
    barrio: ""
  };

  // Este objeto tiene los datos del Concepto Médico del Certificado Ocupacional:
  public objetoSectionConcepto : any = {
    conclusionesOcupacionales : {
      nomb : "",
      nume : "",
      lab : "",
      serv : "",
      rest : ""
    },
    conductasOcupacionales : [],
    recomendaciones : [],
    conceptoMedico : ""
  }

  // Este objeto tiene los datos de las firmas del Certificado Ocupacional:
  public objetoSectionFirmas : any = {
    medicoAtencion : "",
    descripcionMedico : "",
    registroMedico : "",
    imagenAfiliado : "",
    imagenFirma : ""
  }

  // Este objeto contiene todas las pregunstas del Certificado Ocupacional
  // para luego ser utilizado en diferentes objetos de las Section del certificado:
  public objetoCertificadoPreguntas : CertificadoPreguntasEntity = {
    conceptoMedico : "",
    tipoValoracion : "",
    cumplimientoValoracion : [],
    conclusionesOcupacionales : "",
    conductasOcupacionales : [],
    recomendaciones : [],
    profesion : ""
  }

  // Este objeto contiene las imagenes del Certificado Ocupacional:
  public objetoImagenesReponse : ObjetoImagenesReponseEntity = {
    id : "",
    fechaVersion : "",
    imagenFirma : "",
    imagenLogo : "",
    imagenAfiliado : ""
  }

  // Este objeto tiene los datos del afiliado y colaborardor
  // del Certificado Ocupacional:
  public objetoCertificadoDatos: CertificadoDatosEntity = {
    barrio: "",
    ciudad: "",
    descripcionMedico: "",
    direccion: "",
    empresa: "",
    fechaAtencion: null,
    fechaNacimiento: null,
    medicoAtencion: "",
    nit: "",
    nombre: "",
    numeroIdentificacion: "",
    registroMedico: "",
    sector: "",
    sexo: "",
    tipoIdentificacion: "",
    cargo :""
  };

  public objetoPermisos : any = {
    imprimir : false,
    descargar : false,
    filtros : false
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private servicioCertificado: ServicioCertificadoOcupacionalService,
    private servicioImagenes : ServicioImagenesService,
    private dataPermisos : DataPermisosService
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.objetoCertificado.codigoBaseDatos = params["codigoBaseDatos"];
      this.objetoCertificado.id = params["id"];

      this.objetoImagenes.codigoBaseDatos = params["codigoBaseDatos"];
      this.objetoImagenes.id = params["id"];
      this.objetoImagenes.idEntidad = params["idEntidad"];
    });

    this.getPermisos();
  }

  public async getPermisos () {

    let ruta : string = await this.activatedRoute.snapshot.url[0].path;
    let result : any = await this.dataPermisos.getPermisos(ruta);

    if( result != null ) {
      this.objetoPermisos = result;
    }

  }

  ngOnInit() {
    this.getResponse();
    this.getResponseImagenes();
  }

  // Este método obtiene los datos principales del certificado (Afiliado y Médico):
  private async getResponse() {
    try {

      // Objeto datos afiliado y medico:
      let response = await this.servicioCertificado.getResponseCertificadoOcupacional(
        this.objetoCertificado
      );

      // Objeto datos preguntas:
      let responsePreguntas = await this.servicioCertificado.getResponseCertificadoOcupacionalPreguntas(
        this.objetoCertificado
      );

      if (response != null) {
        response.subscribe((data: any) => {

          // Se llena el objeto principal de datos:
          this.objetoCertificadoDatos = data;

          // Se llena el objeto de la cabecera del certificado:
          this.objetoSectionCertificado = {
            fechaAtencion: this.objetoCertificadoDatos.fechaAtencion,
            ciudad: this.objetoCertificadoDatos.ciudad,
            empresa: this.objetoCertificadoDatos.empresa
          };

          // Se llena el objeto del colaborador del certificado:
          this.objetoSectionColaborador = {
            nombre: this.objetoCertificadoDatos.nombre,
            numeroIdentificacion: this.objetoCertificadoDatos.numeroIdentificacion,
            tipoIdentificacion: this.objetoCertificadoDatos.tipoIdentificacion,
            fechaNacimiento: this.objetoCertificadoDatos.fechaNacimiento,
            sexo: this.objetoCertificadoDatos.sexo,
            direccion: this.objetoCertificadoDatos.direccion,
            sector: this.objetoCertificadoDatos.sector,
            barrio: this.objetoCertificadoDatos.barrio
          };

          // Se llena el objeto de imagenes de firmas del certificado:
          this.objetoSectionFirmas.medicoAtencion = this.objetoCertificadoDatos.medicoAtencion;
          this.objetoSectionFirmas.descripcionMedico = this.objetoCertificadoDatos.descripcionMedico;
          this.objetoSectionFirmas.registroMedico = this.objetoCertificadoDatos.registroMedico;

          if (responsePreguntas != null) {
            responsePreguntas.subscribe((data: any) => {

              // Objeto datos principal preguntas del certificado:
              this.objetoCertificadoPreguntas = data;
              this.objetoSectionColaborador.cargo = data['profesion'];
              // Se llena el objeto del conpeto médico:
              this.objetoSectionConcepto = {
                conclusionesOcupacionales : this.objetoCertificadoPreguntas.conclusionesOcupacionales,
                conductasOcupacionales : this.objetoCertificadoPreguntas.conductasOcupacionales,
                recomendaciones : this.objetoCertificadoPreguntas.recomendaciones,
                conceptoMedico : this.objetoCertificadoPreguntas.conceptoMedico
              }

              //console.log(data);
            });
          }

          //console.log(data);
        });
      }

    } catch (exception) {
      console.log("Reporte Certificado Ocupacional: \n" + exception);
    }
  }

  // Este método obtiene los datos de las imágenes del reporte:
  private async getResponseImagenes() {
    try {
      let result = await this.servicioImagenes.getResponseImagenes(this.objetoImagenes);

      if( result != null ) {
        result.subscribe((data : any) => {
          this.objetoImagenesReponse = data;

          this.objetoSectionFirmas.imagenAfiliado = this.objetoImagenesReponse.imagenAfiliado;
          this.objetoSectionFirmas.imagenFirma = this.objetoImagenesReponse.imagenFirma;

          //console.log(data);
        });
      }

    } catch(exception) {
      console.log(exception);
    }
  }

  // Este método sirve para ser llamados desde el nav bar y actualizar el certificado:
  public onGenerated( param: any ) {
    this.getResponse();
    this.getResponseImagenes();

    //console.log("Reporte Certificado Ocupacional");
  }

  // Este método imprime el certificado:
  public onImprimir( param : any ) {

    let printContents : any, popupWin : any;

    printContents = document.getElementById('imprimirContainer').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <style>
            body {
              font-family: 'Gentium Basic', serif;
            }

            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents }</body>
      </html>`
    );

    popupWin.document.close();

    //console.log("Imprimir Certificado Ocupacional");
  }

}